import * as Yup from 'yup';

import { IncidentReportStatus } from 'components/CriticalIncident/interfaces';

import {
    initialValues as followUpInitialValues,
    validationSchema as followUpValidationSchema,
} from './forms/FollowUps/schema';
import {
    initialValues as groupServiceInitialValues,
    validationSchema as groupServiceValidationSchema,
} from './forms/GroupServices/schema';
import {
    initialValues as incidentDocumentationInitialValues,
    validationSchema as incidentDocumentationValidationSchema,
} from './forms/IncidentDocumentation/schema';
import {
    initialValues as individualSupportSessionInitialValues,
    validationSchema as individualSupportSessionValidationSchema,
    auValidationSchema as individualSupportSessionAuValidationSchema,
} from './forms/IndividualSupportSession/schema';
import {
    initialValues as interventionSummaryInitialValues,
    validationSchema as interventionSummaryValidationSchema,
} from './forms/InterventionSummary/schema';
import {
    initialValues as onsiteContactInitialValues,
    validationSchema as onsiteContactValidationSchema,
} from './forms/OnsiteContact/schema';
import {
    initialValues as recommendationInitialValues,
    validationSchema as recommendationValidationSchema,
} from './forms/Recommendations/schema';
import {
    initialValues as riskAssessmentInitialValues,
    validationSchema as riskAssessmentValidationSchema,
} from './forms/RiskAssessments/schema';
import {
    initialValues as reviewInitialValues,
    validationSchema as reviewValidationSchema
} from './forms/Review/schema';
import {
    initialValues as deliveryHoursInitialValues,
    validationSchema as deliveryHoursValidationSchema,
} from './forms/DeliveryHours/schema';
import {
    initialValues as referringManagerInitialValues,
    validationSchema as referringManagerValidationSchema,
} from './forms/ReferringManager/schema';

export const initialValues = {
    id: '',
    caseId: 0,
    activityId: 0,
    status: IncidentReportStatus.Open,
    submittedOn: '',
    submittedBy: '',
    createdOn: '',
    createdBy: '',
    modifiedOn: '',
    modifiedBy: '',
    interventionSummary: interventionSummaryInitialValues,
    incidentDocumentation: incidentDocumentationInitialValues,
    individualSupportSession: individualSupportSessionInitialValues,
    groupService: groupServiceInitialValues,
    onsiteContact: onsiteContactInitialValues,
    followUp: followUpInitialValues,
    recommendation: recommendationInitialValues,
    riskAssessment: riskAssessmentInitialValues,
    review: reviewInitialValues,
    deliveryHours: deliveryHoursInitialValues,
    referringManager: referringManagerInitialValues,
};

export const defaultValidationSchema = Yup.object({
    id: Yup.string(),
    caseId: Yup.number(),
    activityId: Yup.number(),
    status: Yup.string().oneOf(Object.values(IncidentReportStatus)),
    submittedOn: Yup.string().nullable(),
    submittedBy: Yup.string().nullable(),
    createdOn: Yup.string(),
    createdBy: Yup.string(),
    modifiedOn: Yup.string(),
    modifiedBy: Yup.string(),
    interventionSummary: interventionSummaryValidationSchema,
    incidentDocumentation: incidentDocumentationValidationSchema,
    individualSupportSession: individualSupportSessionValidationSchema,
    groupService: groupServiceValidationSchema,
    onsiteContact: onsiteContactValidationSchema,
    followUp: followUpValidationSchema,
    recommendation: recommendationValidationSchema,
    riskAssessment: riskAssessmentValidationSchema,
    review: reviewValidationSchema,
    deliveryHours: Yup.mixed().notRequired(),
    referringManager: Yup.mixed().notRequired(),
});

// AU never visits Risk Assessment / Follow-Ups as standalone sections — that data now lives
// inside individualSupportSession (TPH-1906/1907/1908/1909). Their `.required()` gate fields
// default to `null` and would otherwise stay `null` forever for AU reports, permanently
// blocking submission.
export const auValidationSchema = defaultValidationSchema.shape({
    followUp: Yup.mixed().notRequired(),
    riskAssessment: Yup.mixed().notRequired(),
    deliveryHours: deliveryHoursValidationSchema,
    referringManager: referringManagerValidationSchema,
    individualSupportSession: individualSupportSessionAuValidationSchema,
});

export const getValidationSchema = (isAU: boolean) => (isAU ? auValidationSchema : defaultValidationSchema);
